// Reader to read the file as DataURL
export async function reader(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    if (file instanceof File) {
      const fr = new FileReader();

      fr.onloadend = () => resolve(fr.result as string);
      fr.onerror = () => reject(new Error('Failed to read file'));

      fr.readAsDataURL(file);
    }
  });
}
